import type { Locale } from 'lc-services/types'

export const useOpeningTimes = (
  timetable: {
    endTimeWeek: string
    startTimeWeek: string
  } = {
    endTimeWeek: '18:30',
    startTimeWeek: '9:30',
  },
) => {
  const { locale, t } = useI18n<unknown, Locale>({ useScope: 'global' })

  const localizedTimetable = computed(
    () =>
      Object.fromEntries(
        Object.entries(timetable).map(([key, value]) => [
          key,
          formatTime(value, locale.value),
        ]),
      ) as typeof timetable,
  )
  const message = computed(() =>
    t('contact.openingTimes', localizedTimetable.value!),
  )
  const messageShort = computed(() =>
    t('contact.openingTimesShort', localizedTimetable.value!),
  )

  return {
    ...localizedTimetable.value,
    message,
    messageShort,
  }
}
